import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Stack, Typography} from 'views/components';

import {Translate, ShortDateText} from 'views/module';

const FixedReview = (props) => {
  const newEvent = props.newEvent;
  const setIsStepValid = props.setIsStepValid;

  React.useEffect(() => {
    setIsStepValid(true);
  }, []);

  return (
    <Grid container>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.FixedEvent.StartTime'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            <ShortDateText dateTimestamp={newEvent.eventData.startTime}/>
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.FixedEvent.EndTime'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            <ShortDateText dateTimestamp={newEvent.eventData.endTime}/>
          </Typography>
        </Stack>
      </Grid>
      {
        (newEvent.breaks.breakDuration > 0 && newEvent.breaks.breakCount > 0) &&
            <>
              <Grid item xs={6}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.Breaks.BreakDuration'/>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '14px',
                    }}
                  >
                    <Translate
                      expression="schedule.eventDetail.TimeSection.Minutes"
                      substitute={{breakDuration: newEvent.breaks.breakDuration}}
                    />
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.Breaks.BreakCount'/>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '14px',
                    }}
                  >
                    {newEvent.breaks.breakCount}
                  </Typography>
                </Stack>
              </Grid>
            </>
      }
      <Grid item xs={12}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.FixedEvent.Timezone'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {newEvent.eventData.timezone}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

FixedReview.propTypes = {
  newEvent: PropTypes.object.isRequired,
  eventType: PropTypes.string.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(FixedReview));
